import { useEffect, useRef } from "react";
import { ALLERGIESPMS, PROBLEMSPMS } from "../shared/constants";
import { createPmsListComponent } from "../shared/helpers";
import { ActionKind } from "./form-view-reducer";

export function usePmsSystemEffects(state, dispatch) {

    useEffect(() => {

        if (!state.loadPmsSystem)
            return;

        if (state.pmsSystemVm?.allergyFormFields || state.pmsSystemVm?.diseaseFormFields) {
            const newComponents = { ...state.data.json.components };

            Object.keys(state.data?.json?.components).forEach(key => {
                let newComponent = { ...newComponents[key] };

                if (newComponent.key === ALLERGIESPMS) {
                    newComponent = createPmsListComponent(newComponent, state.pmsSystemVm?.allergyFormFields);
                    Object.values(newComponent.childComponents).forEach((comp: any, index) => {
                        comp.required = newComponent.required;
                    });
                    newComponents[key] = newComponent;
                }
                if (newComponent.key === PROBLEMSPMS) {
                    newComponent = createPmsListComponent(newComponent, state.pmsSystemVm?.diseaseFormFields);

                    Object.values(newComponent.childComponents).forEach((comp: any, index) => {
                        comp.required = newComponent.required;
                    });

                    newComponents[key] = newComponent;
                }
            });

            dispatch({ type: ActionKind.SET_COMPONENTS, payload: newComponents });
        }
       
    
        
        dispatch({ type: ActionKind.SET_PMSSYSTEMLOADED, payload: true });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.loadPmsSystem]);

    // Track if PMS system has been loaded for this form
    const pmsSystemLoadedRef = useRef(false);

    // PMS System: Load if needed
    useEffect(() => {

        if (pmsSystemLoadedRef.current || !state.data?.json?.components)
            return;

        dispatch({ type: ActionKind.SET_LOADPMSSYSTEM, payload: true });

        pmsSystemLoadedRef.current = true;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.pmsSystemVm, state.data?.json?.components]);
}
